import chevron from "../photos/BiChevronsRight.svg";

const StartPage = ({
  openCreateFunc,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  setopenMenu,
  openJoinFunc,
  t,
}) => {
  return (
    <div className="App-header">
      <div
        className="button-primary white-fill button-text-l text-color-black shadow-black box-button-center"
        onClick={() => openCreateFunc("classic room")}
      >
        {t("new-room")}
      </div>
      <div
        className="swipe-area"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <p
          className="button-tertiary-s button-text-s text-color-black"
          style={{ maxHeight: "25px", marginBottom: "7px" }}
          onClick={() => setopenMenu(true)}
        >
          {t("menu")}
        </p>
        <img
          className="stuttering-arrow-right"
          src={chevron}
          onClick={() => setopenMenu(true)}
          alt=""
        />
      </div>
      <div
        className="button-primary white-fill button-text-l text-color-black shadow-black box-button-center"
        onClick={() => openJoinFunc()}
      >
        {t("join-room")}
      </div>
    </div>
  );
};

export default StartPage;
